module.exports = __webpack_public_path__ + "static/media/cast-in.0a7e7abe.jpg";